<template>
    <div class="memorandum_create_block ">
        <div class="list_mem_create">
            <div class="panel">
                <div class="panel-hdr bg-primary-500 bg-success-gradient">
                    <h2>
                        POS Sync: {{this.provider.human_name}}
                    </h2>
                    <div class="panel-toolbar" v-if="!is_excel">
                        <button class=" btn  btn-sm btn-success shadow-0  waves-effect waves-themed" v-on:click="show_settings">
                            {{__t('BASE')}} <i class="fal fa-cog"></i>
                        </button>
                    </div>
                </div>

                <div class="panel-container show" >
                    <div class="panel-content">
                        <b-overlay :show="is_load" rounded="sm">
                            <div class="work_area" v-if="is_load_complete">
                                <pos_empty @excel_ready="go_next_step_excel" :pos_item="pos_item" v-if="!pos_item.is_init"></pos_empty>
                                <pos_sync v-if="is_load_complete && pos_item.is_init"></pos_sync>
                            </div>
                        </b-overlay>
                    </div>

                    <div class="panel-content py-2 rounded-bottom border-faded border-left-0 border-right-0 border-bottom-0 text-muted d-flex">
                        <span class="badge badge-info fw-400 mr-2 pt-1">
                            {{this.provider.human_name}} :  {{provider.id}}
                        </span>
                    </div>
                </div>
            </div>

            <pos_settings_modal></pos_settings_modal>
        </div>
    </div>
</template>

<script>
import Pos_settings_modal from "./pos_settings/pos_settings_modal";
import Pos_empty from "./pos_empty";
import Pos_sync from "./pos_sync/pos_sync";
import {mapGetters} from "vuex";

export default {
    name: "pos",
    components: {Pos_sync, Pos_empty, Pos_settings_modal},
    props : {
        provider : {
            type : Object
        }
    },

    data() {
        return {

        }
    },

    created() {
        EventBus.$on('loaded_api',this.load_pos_info);
        EventBus.$on('reload_pos_base',this.load_pos_info);
        if(window.hasOwnProperty('pos_api')) {
            this.load_pos_info();
        }
    },
    methods : {

        go_next_step_excel(upload_file) {
            console.log('go_next_step',upload_file);
            this.pos_item.is_init = true;
            this.$store.dispatch('pos/SET_LOAD_COMPLETE',true);

            this.pos_item.pos_params.extra_request = {
                "file" : upload_file
            };
        },

        async load_pos_info() {
            this.$store.dispatch('pos/LOAD_PROVIDER',this.prov_id);
        },

        show_settings() {
            EventBus.$emit('pos_edit');
        },
    },

    computed : {
        prov_id () {

            return parseInt(this.provider.id);
        },

        is_excel() {
            return this.provider.type === 'excel' || this.provider.type === 'smok';
        },

        ...mapGetters({
            'pos_item': "pos/getPos",
            'is_load' : "pos/is_load",
            'is_load_complete' : "pos/is_load_complete"
        }),

    }
}
</script>

<style scoped>

</style>
